// extracted by mini-css-extract-plugin
export default {"title":"theme_title__19VZn","childrenContainer":"theme_childrenContainer__BEWGL","logoContainer":"theme_logoContainer__lYkoj","logo":"theme_logo__U1qpg"};